import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.9844C15.866 19.9844 19 16.8504 19 12.9844C19 9.11838 15.866 5.98438 12 5.98438C8.13401 5.98438 5 9.11838 5 12.9844C5 16.8504 8.13401 19.9844 12 19.9844ZM12 16.9844C14.2091 16.9844 16 15.1935 16 12.9844C16 10.7752 14.2091 8.98438 12 8.98438C9.79086 8.98438 8 10.7752 8 12.9844C8 15.1935 9.79086 16.9844 12 16.9844Z"
        fill="var(--svg-color-main, #FF4C00)"
      />
    </svg>
  )
}
